import angular from 'angular'
import selectTreeDirective from './selectTreeDirective'

export default angular
    .module('app.selectTree', [])
    .directive('selectTree', selectTreeDirective)
    .name



// WEBPACK FOOTER //
// ./src/components/selectTree/index.js